import React from "react";
import PortfolioComponent from "./PortfolioComponent";
import { Element } from "react-scroll";


function Portfolio() {

  const portfolio = [
    {
      id: 1,
      title: "Instawave",
      image: "Images/social.png",
      code: "https://github.com/leander006/social-media-app",
      link: "https://instawave.vercel.app/"
    },
    {
      id: 2,
      title: "Holla",
      image: "Images/videoCall.png",
      code: "https://github.com/leander006/safe-chat-frontend",
      link: "https://safechat.vercel.app/",
    },
    {
      id: 3,
      title: "Freeconnect",
      image: "Images/freechat.png",
      code: "https://github.com/leander006/safe-chat-frontend",
      link: "https://client-share.vercel.app/",
    },
    {
      id: 4,
      title: "News website",
      image: "Images/news.png",
      code: "https://github.com/leander006/News-App",
    },
    {
      id: 5,
      title: "Dog Service website",
      image: "Images/dog.png",
      code: "https://github.com/leander006/Dog-service-website",
    },
    {
      id: 6,
      title: "Quora website",
      image: "Images/quora.png",
      code: "https://github.com/leander006/Forum-discussion",
    },
  ];

  return (
    <Element
      name="portfolio"
      className="h-full px-4 lg:mt-16 text-[#93a2b8]" >
      <div className="flex flex-col w-full">
        <h1 className="lg:hidden flex text-xl font-WorkSans font-bold pt-16 pb-8 lg:pb-0">
          Portfolio
        </h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 my-4 lg:pb-8">
        {portfolio.map(({ id, title, image, link, code }) => (
          <PortfolioComponent key={id} title={title} image={image} link={link} code={code} />
        ))}
      </div>
    </Element>
  );
}

export default Portfolio;
